import { Component } from '@angular/core'
import { Checkout, Depot } from 'depoto-core/src/entities/index'
import { CoreService } from '../../../../services'
import { FormControl, FormGroup } from '@angular/forms'
import { Emittable, Emitter } from '@ngxs-labs/emitter'
import { PlugplayState } from '../../states/plugplay-state.service'
import { Institution } from 'depoto-core/src/entities/Institution'
import { User } from 'depoto-core/src/entities'

@Component({
  selector: 'app-test-bbb',
  templateUrl: './step2.component.html',
  styleUrls: ['./step2.component.scss'],
})
export class Step2Component {
  @Emitter(PlugplayState.setHighestStepVisited)
  private readonly setHighestStepVisited: Emittable<number>
  @Emitter(PlugplayState.setActive)
  private readonly setActive: Emittable<number>
  @Emitter(PlugplayState.setHighestLastStepCompleted)
  public readonly setHighestLastStepCompleted: Emittable<number>
  public readonly checkoutsGroup: FormGroup = new FormGroup<any>({})
  public readonly depotsGroup: FormGroup = new FormGroup<any>({})
  private instanceCount = 0
  public checkoutMap = new Map<number, any>()
  public depotMap = new Map<number, any>()
  institution: Partial<Institution>

  constructor(private readonly core: CoreService) {
    this.setActive.emit(1)
    this.setHighestStepVisited.emit(1)
    this.loadInstitution()
    this.loadDepots()
    this.loadCheckouts()
  }

  private async loadInstitution(): Promise<void> {
    const resp = await this.core.services.institution.getList({}, { id: null })
    this.institution = resp?.items?.[0]
  }

  private loadDepots(): Promise<any> {
    return this.core.services.depot
      .getList(
        { page: 0, sort: 'id', direction: 'DESC' },
        { id: null, name: null, deletable: null, checkouts: { id: null }, institution: { id: null } },
      )
      .then(response => {
        this.depotMap = new Map(response?.items?.map(i => [i.id, i.deletable]) || [])
        response?.items?.forEach(item => {
          this.depotMap.set(item.id, item)
          this.depotsGroup.addControl(item.id, new FormControl(item.name))
        })
        this.addItem(this.depotsGroup)
      })
  }
  private loadCheckouts(): Promise<any> {
    return this.core.services.checkout
      .getList(
        { page: 0, sort: 'id', direction: 'DESC' },
        {
          id: null,
          name: null,
          deletable: null,
          depots: { id: null },
        },
      )
      .then(response => {
        this.checkoutMap = new Map(response.items.map(i => [i.id, i.deletable]))
        response.items.forEach(item => {
          this.checkoutMap.set(item.id, item)
          this.checkoutsGroup.addControl(item.id, new FormControl(item.name))
        })
        this.addItem(this.checkoutsGroup)
      })
  }

  public save(id: string, type: 'checkouts' | 'depots'): void {
    if (type === 'depots') {
      if (this.depotsGroup.get(id).value) {
        if (id.includes('new-')) {
          this.core.services.depot
            .create(
              new Depot({
                name: this.depotsGroup.get(id).value,
                checkouts: Array.from(this.checkoutMap.keys()).map(id => ({ id })),
                institution: { id: this.institution?.id },
                users: [this.currentUser],
              }),
            )
            .then(() => {
              this.loadDepots().then(() => this.depotsGroup.removeControl(id))
              this.core.services.user.setCurrentUser(this.currentUser.email)
            })
        } else {
          this.core.services.depot.updatePart({ id: +id, name: this.depotsGroup.get(id).value }).then(() => {
            this.core.services.user.setCurrentUser(this.currentUser.email)
          })
        }
      }
    } else {
      if (this.checkoutsGroup.get(id).value) {
        if (id.includes('new-')) {
          this.core.services.checkout
            .create(
              new Checkout({
                name: this.checkoutsGroup.get(id).value,
                depots: Array.from(this.depotMap.keys()).map(id => ({ id })),
                institution: { id: this.institution?.id },
                users: [this.currentUser],
              }),
            )
            .then(() => {
              this.loadCheckouts().then(() => this.checkoutsGroup.removeControl(id))
              this.core.services.user.setCurrentUser(this.currentUser.email)
            })
        } else {
          this.core.services.checkout.updatePart({ id: +id, name: this.checkoutsGroup.get(id).value }).then(() => {
            this.core.services.user.setCurrentUser(this.currentUser.email)
          })
        }
      }
    }
  }

  public addItem(formGroup: FormGroup): void {
    this.instanceCount++
    const groupLength = Object.keys(formGroup.controls).length
    if (groupLength === 0) {
      formGroup.addControl('new-' + this.instanceCount, new FormControl({ value: '', disabled: true }))
    } else {
      const doesTheLastItemHaveValue = formGroup.get(
        Object.keys(formGroup.controls)[groupLength > 0 ? groupLength - 1 : groupLength],
      ).value
      if (doesTheLastItemHaveValue) {
        formGroup.addControl('new-' + this.instanceCount, new FormControl({ value: '', disabled: true }))
      }
    }
  }

  private delete(id: string, type: 'checkouts' | 'depots'): void {
    if (type === 'checkouts') {
      if (id.includes('new-')) {
        this.checkoutsGroup.removeControl(id)
      } else {
        this.core.services.checkout.delete(new Checkout({ id }))
        this.checkoutsGroup.removeControl(id)
      }
    } else {
      if (id.includes('new')) {
        this.depotsGroup.removeControl(id)
      } else {
        this.core.services.depot.delete(new Depot({ id }))
        this.depotsGroup.removeControl(id)
      }
    }
  }

  public deleteDialog(id: string, type: 'checkouts' | 'depots'): void {
    this.delete(id, type)
  }

  trackById(index: number, item: { key: string; value: any }) {
    return item.key
  }

  order(a: { key }, b: { key }): number {
    return 0
  }

  private get currentUser(): User {
    return this.core.services.user.user
  }
}
